
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { RouterKeysMap, routerKeysMap, routerNames } from '@/const/route-key-map'
import { VerifyErrorType } from '@/const/media'

type Step = {
  name: string;
  index: number;
  isError: boolean;
}

@Component({
  name: 'HeaderStep'
})
export default class HeaderStep extends Vue {
  @Prop({ default: 1, type: Number }) readonly curStep!: number
  @Prop({ default: false, type: Boolean }) readonly isError!: number
  @State('errorObj', { namespace: 'verify' }) errorObj: any
  @State('hasVisited', { namespace: 'verify' }) hasVisited: string[]

  get steps(): Step[] {
    return routerNames.map((name: keyof RouterKeysMap, idx) => {
      const subFields = routerKeysMap[name]
      return {
        name,
        index: idx + 1,
        isError: subFields.some(field => this.errorObj?.[field]?.type === VerifyErrorType.BLOCK),
        isLoading: subFields.some(field => this.errorObj?.[field]?.type === VerifyErrorType.LOADING),
        isWarning: subFields.some(field => this.errorObj?.[field]?.type === VerifyErrorType.WARNING)
      }
    })
  }

  headerNext(step: Step): void {
    if (step.index > this.curStep) {
      this.$emit('next', step.index)
    } else {
      this.$router.push({ name: step.name, query: {
        ...this.$route.query
      }})
    }
  }
}
